import React from 'react';

const DonateButton = () => {
    // Found in legacy code:
    // ID: buy_btn_1SeDrLFSl8oRCHamem6Tlkj8
    // Key: pk_live_51SeDWYFSl8oRCHammFWCgpgN02mWowEjX8RhBVHtgZfKrhTeK2eNR2C1qR2vpXZOO5qgOqVcE3dwIxiTE6brmgoz00gVL4jhAr

    return (
        <div style={{ display: 'inline-block' }}>
            <stripe-buy-button
                buy-button-id="buy_btn_1SeDrLFSl8oRCHamem6Tlkj8"
                publishable-key="pk_live_51SeDWYFSl8oRCHammFWCgpgN02mWowEjX8RhBVHtgZfKrhTeK2eNR2C1qR2vpXZOO5qgOqVcE3dwIxiTE6brmgoz00gVL4jhAr"
            >
            </stripe-buy-button>
        </div>
    );
};

export default DonateButton;
